exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deconnection-dialog {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: block;\n  overflow: hidden;\n  margin: 0;\n  padding: 15px; }\n\n.deconnection-dialog h2 {\n  text-align: center;\n  font-size: 1.5em;\n  padding: 0 0 7px 0;\n  margin: 0;\n  border-bottom: solid 1px #c8c8c8; }\n\n.deconnection-dialog p {\n  font-size: 1em;\n  text-align: left; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/profile/edition/dialog/error-dialog.component.scss
// module id = ../../../../../src/app/profile/edition/dialog/error-dialog.component.scss
// module chunks = main